
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"de":{"action.label":"GeoPackage-Datei ...","dialog.title":"GeoPackage-Datei wird erstellt","disabled.tooltip":"~Es sind keine unterstützen Layer vorhanden."},"en":{"action.label":"GeoPackage file ...","dialog.title":"Generating GeoPackage file","disabled.tooltip":"~There are no supported Layers."}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();